import { getAuth, onAuthStateChanged, signOut } from "firebase/auth"; // Upewnij się, że importujesz odpowiednie funkcje
import { useNavigate } from "react-router-dom";

export function AuthProvider() {
    const navigate = useNavigate();
    const auth = getAuth(); // Inicjalizacja instancji auth

    function checkAuth() {
        onAuthStateChanged(auth, (user) => {
            if(!user){
                navigate('/sign-in');
            }
        })
    }
    
    function logout() {
        signOut(auth).then(() => {
            navigate('/sign-in');
        }).catch((error) => {
            console.error("Error signing out:", error); // Dodaj obsługę błędów
        });
    }

    return {
        checkAuth,
        logout
    }
}

